<template>

	<div class="list-content">
		<ul class="type-gallery row row-cols-1 row-cols-sm-2 row-cols-lg-4">

			<li class="col" v-for="(item, index) in noticeList" :id="'item-' + item.idx">
				<a href="javascript:;" @click="goView(item)">
					<div class="thumb-box" v-if="item.thumbFile !== null && item.thumbFile !== ''" :style="'background-image:url(' + APIs.BOARD_FILES_SHOW + item.thumbIdx + ');'"></div>
					<div class="thumb-box" v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);" ></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim">{{ item.cateName }}</span>
							<span class="sec" v-if="item.isNotice">공지</span>
						</div>
						<h3 :style="{ color : item.opt3 }" class="tit">{{ item.title }}</h3>
						<p class="desc">
							{{ item.contentText }}
						</p>
						<ul class="info">
							<li class="like"><span class="blind">좋아요</span>{{ item.likeCount }}</li>
							<li class="view"><span class="blind">조회수</span>{{ item.views }}</li>
<!--							<li class="auth"><span class="blind">작성자</span>{{ item.writerDec }}</li>-->
						</ul>
					</div>
				</a>
			</li>

			<li class="col" v-for="(item, index) in boardList" :id="'item-' + item.idx">
				<a href="javascript:;" @click="goView(item)">
					<div class="thumb-box" v-if="item.thumbFile !== null" :style="'background-image:url(' + APIs.BOARD_FILES_SHOW + item.thumbIdx + ');'"></div>
					<div class="thumb-box" v-else style="background-image:url(/ssflex/assets/img/common/img_thumb.svg);" ></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim">{{ item.cateName }}</span>
							<span class="sec" v-if="item.isNotice">공지</span>
						</div>
						<h3 :style="{ color : item.opt3 }" class="tit">{{ item.title }}</h3>
						<p class="desc">
							{{ item.contentText }}
						</p>
						<ul class="info">
							<li class="like"><span class="blind">좋아요</span>{{ item.likeCount }}</li>
							<li class="view"><span class="blind">조회수</span>{{ item.views }}</li>
<!--							<li class="auth"><span class="blind">작성자</span>{{ item.writerDec }}</li>-->
						</ul>
					</div>
				</a>
			</li>


<!--			<li class="col">
				<a href="#">
					<div class="thumb-box" style="background-image: url(/ssflex/assets/img/temp/temp_img_01.png);"></div>
					<div class="text-box">
						<div class="cate bedge-line">
							<span class="prim">건축</span>
							<span class="sec">엔지니어링</span>
						</div>
						<h3 class="tit">
							그들에게 가지에 인생을 황금시대다. 없으면, 석가는 대중을 온갖 힘차게 주며, 때에, 무엇을 이는 그리하였는가? 얼마나 무엇을 피부가 품에 곳이 봄바람이다.
						</h3>
						<p class="desc">
							듣기만 소금이라 보내는 미인을 되는 예수는 피부가 자신과 이것이다. 생명을 가는 새 미묘한 꾸며 있는가? 원질이 인간이 청춘의 찾아다녀도, 보이는 말이다. 트고, 과실이 곳으로 가슴이 소리다.이것은 살 없으면 설레는 튼튼하며, 교향악이다. 같이, 사랑의 하는 어디 인간은 되려니와, 봄바람이다. 그것을 옷을 귀는 보이는 것은 황금시대다. 그들은 있는 이상의 살았으며, 이상은 군영과 노래하며 위하여서.
						</p>
						<ul class="info">
							<li class="like"><span class="blind">좋아요</span>54</li>
							<li class="view"><span class="blind">조회수</span>123</li>
						</ul>
					</div>
				</a>
			</li>-->



		</ul>
	</div>

</template>

<script>
export default {
	name: "listGallery",
	props: {
		forApp: {
			type: Boolean,
			default: false,
		},
		boardInfo: Object,
		noticeList: Array,
		boardList: Array,
	},
	data() {

		return {

		}
	},
	created() {

	},
	mounted() {

	},
	methods: {

		goView( _item ) {
			if ( this.forApp ) {
				this.goAppBoard( _item.boardKey, _item.idx )
			}
			this.$emit("goBoardOne", _item.idx);
		}

	},
	watch: {
	}
}
</script>

<style scoped>

</style>